class SelectField extends React.Component {
    constructor(props) {
        super(props);
        let bindFunctions = () => {
            this.state = { bShowFullName: true };
            this.onFocus = this.onFocus.bind(this);
            this.onBlur = this.onBlur.bind(this);
        }

        if (typeof window !== 'undefined') {
            let screenWidth = window.innerWidth;
            if (screenWidth < 480)
                this.state = { bShowFullName: false };
            else
                bindFunctions();
        }
        else {
            bindFunctions();
        }
    }

    onFocus(e) {
        this.setState({
            bShowFullName: false
        });
    }

    onBlur(e) {
        this.setState({
            bShowFullName: true
        });
        if (this.props.onBlur != null)
            this.props.onBlur(e);
    }

    render() {
        var options = [];
        var enabledText = {
            color: '#6d6e71'
        };
        var disabledText = {
            color: '#999999'
        };

        for (let i = 0; i < this.props.values.length; i++) {
            let option = this.props.values[i];
            if (option.value == "" || option.Value == "" || option.FullName == "" || option.Text == "" || option.text == "") {
                option.label = "------";
            }
            if (option.hasOwnProperty("Enabled")) {
                if (option.hasOwnProperty("FullName") && this.props.bShowFullName && this.state.bShowFullName)
                    options.push(<option key={i} value={option.Value} disabled={option.Enabled ? false : true} style={option.Enabled ? enabledText : disabledText} label={option.label}>{option.FullName}</option>);
                else
                    options.push(<option key={i} value={option.Value} disabled={option.Enabled ? false : true} style={option.Enabled ? enabledText : disabledText} label={option.label}>{option.Text}</option>);
            }
            else {
                options.push(<option key={i} value={option.value} label={option.label}>{option.text}</option>);
            }
        }

        var style = {};
        var divStyle = {};
        if (this.props.alignBottom) {
            style.alignSelf = 'flex-end';
            divStyle.width = '100%';
            divStyle.display = 'flex';
        }

        var returnHTML = [];
        if (this.props.SmallSelect) {

            style.marginLeft = '2%'
            if (this.props.disabled)
                style.background = '#EBEBE4';

            let selectclass = "small-select";
            if (this.props.className && this.props.className != "") {
                selectclass = this.props.className;
            }

            returnHTML.push(
                <select
                    style={style}
                    disabled={this.props.disabled ? true : false}
                    className={selectclass}
                    onChange={(e) => { this.props.onFieldChanged(e.target.value); }}
                    value={this.props.value || ''}
                    key={this.props.id}
                    onFocus={(e) => { this.onFocus(e); }}
                    onBlur={(e) => { this.onBlur(e); }}
                    aria-labelledby={this.props.ariaLabelledBy}>
                    {options}
                </select>
            );
        }
        else {
            let selectclass = "";
            selectclass = this.props.mileage ? selectclass + "mileage-select " : selectclass + "";
            selectclass = this.props.error ? selectclass + "inputError " : selectclass + "";
            selectclass = this.props.feRequired ? selectclass + " fe-required-field " : selectclass + "";
            selectclass = selectclass + (this.props.className || "");

            if (this.props.highlight && this.props.highlight != "")
                selectclass = selectclass + " " + this.props.highlight;

            if (this.props.disabled)
                style.background = '#EBEBE4';
            if (this.props.isPrice)
                style.margin = '0';

            var mileage = "";
            if (this.props.mileage)
                mileage = "mileage-select-div";
            if (this.props.mileageinch)
                mileage = "mileageinch-select-div";

            var label = "";
            if (!this.props.hasLabel) {
                label =
                    this.props.isRequired ?
                        <label htmlFor={this.props.id} id={this.props.id + "label"}> <span className="required-red"> *</span>{this.props.placeholder} {"\n"}</label>
                        :
                        <label className="label-left" htmlFor={this.props.id} id={this.props.id + "label"}>{this.props.placeholder} {"\n"}</label>
            }

            var key = this.props.id + "Key";
            returnHTML =
                <>
                    {label}
                    <select
                        style={style}
                        id={this.props.id}
                        disabled={this.props.disabled ? true : false}
                        className={selectclass}
                        onChange={(e) => { this.props.onFieldChanged(e.target.value); }}
                        value={this.props.value || ''}
                        onFocus={(e) => { this.onFocus(e); }}
                        onBlur={(e) => { this.onBlur(e); }}
                        aria-labelledby={this.props.ariaLabelledBy}>
                        {options}
                    </select>
                    <p style={{ margin: '0' }} className="validationError">
                        <span dangerouslySetInnerHTML={{ __html: this.props.errorText }}></span>
                    </p>
                </>;
        }

        return (
            returnHTML
        );
    }
}

export default SelectField;
global.SelectField = SelectField;